var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"sidebar-container"},[_c('Sidebar')],1),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"navbar"},[_c('Navbar')],1),_c('div',{staticClass:"breadcrumb-container"},[_c('Breadcrumb')],1),_c('AppMain')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }